const offersApi = require('../api/offers');
const { updateLootgemBalance } = require('./UserActions');

const MIN_OFFERS_UPDATE = 1000 * 60 * 5; // 5 minutes
const FETCH_OFFERS_TIMEOUT = 1000 * 30; // 30 seconds

function fetchOffersInProgress() {
  return {
    type: 'FETCH_OFFERS_IN_PROGRESS',
    timestamp: Date.now(),
  };
}

function fetchOffersSuccessful(offers) {
  return {
    type: 'FETCH_OFFERS_SUCCESSFUL',
    offers,
    timestamp: Date.now(),
  };
}

function fetchTakenOffersSuccessful(offers) {
  return {
    type: 'FETCH_TAKEN_OFFERS_SUCCESSFUL',
    offers,
    timestamp: Date.now(),
  };
}

function fetchOffersFailed(reason) {
  return {
    type: 'FETCH_OFFERS_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchOffersTaken() {
  return (dispatch, getState) => {
    const state = getState();
    const { apiUrl } = state.auth;
    const { token } = state.auth;

    if (!apiUrl || !token) {
      return Promise.resolve();
    }

    return offersApi.fetchOffersTaken(apiUrl, token).then(({ offers }) => {
      dispatch(fetchTakenOffersSuccessful(offers || []));
      return offers;
    });
  };
}

function fetchOffers({ country, platform } = {}) {
  return (dispatch, getState) => {
    dispatch(fetchOffersInProgress());

    const state = getState();
    const { apiUrl } = state.auth;

    if (!apiUrl) {
      return Promise.resolve();
    }

    return offersApi.fetchOffers(apiUrl, { country, platform }).then(
      (offers) => {
        dispatch(fetchOffersSuccessful(offers));
        dispatch(fetchOffersTaken());
        return offers;
      },
      (error) => {
        dispatch(fetchOffersFailed(error));
        throw error;
      },
    );
  };
}

function shouldFetchOffers(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.offers;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    if (
      new Date(lastSuccessfulFetch).getUTCDate() !== new Date().getUTCDate()
    ) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_OFFERS_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_OFFERS_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchOffersIfNeeded({ country, platform } = {}) {
  return (dispatch, getState) => {
    if (shouldFetchOffers(getState())) {
      return dispatch(fetchOffers({ country, platform }));
    }
    return Promise.resolve();
  };
}

function invalidateOffers() {
  return {
    type: 'INVALIDATE_OFFERS',
    timestamp: Date.now(),
  };
}

function takeUpOnOfferSuccessful(offerId, offer) {
  return {
    type: 'TAKE_UP_ON_OFFER_SUCCESSFUL',
    offerId,
    offer,
    timestamp: Date.now(),
  };
}

function takeUpOnOffer(offerId) {
  return (dispatch, getState) => {
    const state = getState();
    const { apiUrl } = state.auth;
    const { token } = state.auth;

    if (!apiUrl || !token) {
      return Promise.resolve();
    }

    return offersApi
      .takeUpOnOffer(apiUrl, token, offerId)
      .then((response) => {
        dispatch(takeUpOnOfferSuccessful(offerId, response.offer));
        if (typeof response.newLootgemBalance === 'number') {
          dispatch(updateLootgemBalance(response));
        }
        return response;
      })
      .catch(() => Promise.resolve());
  };
}

module.exports = {
  invalidateOffers,
  fetchOffersIfNeeded,
  fetchOffers,
  fetchOffersTaken,
  takeUpOnOffer,
};
